import { render, staticRenderFns } from "./takeawayOrderDetailPage.vue?vue&type=template&id=72b39d40&scoped=true&"
import script from "./takeawayOrderDetailPage.vue?vue&type=script&lang=js&"
export * from "./takeawayOrderDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./takeawayOrderDetailPage.vue?vue&type=style&index=0&id=72b39d40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b39d40",
  null
  
)

export default component.exports